/* Bergblut Winterfeuer — gemeinsames Verhalten aller Sektionen.
   Alles per Delegation, damit der Theme-Editor Sektionen nachladen kann. */
(function () {
  'use strict';

  if (window.__bbwWinterfeuer) return;   // Skript wird von jeder Sektion geladen
  window.__bbwWinterfeuer = true;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ——— Einblenden beim Scrollen ——— */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.bbw-root .reveal:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  /* ——— Scroll-Fortschrittsbalken ——— */
  function initProgress() {
    var bar = document.querySelector('.bbw-progress');
    if (!bar) return;
    var onScroll = function () {
      var h = document.documentElement;
      var p = h.scrollTop / Math.max(1, h.scrollHeight - h.clientHeight);
      bar.style.width = (p * 100) + '%';
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ——— Countdown ——— */
  function initCountdown(root) {
    var els = (root || document).querySelectorAll('.bbw-cd[data-deadline]');
    Array.prototype.forEach.call(els, function (el) {
      if (el._bbwTimer) clearInterval(el._bbwTimer);
      var raw = (el.getAttribute('data-deadline') || '').trim();
      var target = Date.parse(raw.replace(' ', 'T'));
      if (isNaN(target)) { el.style.display = 'none'; return; }
      var slots = el.querySelectorAll('[data-unit]');
      var note = el.parentNode ? el.parentNode.querySelector('.cd-over') : null;
      var tick = function () {
        var s = Math.max(0, Math.floor((target - Date.now()) / 1000));
        var vals = { d: Math.floor(s / 86400), h: Math.floor(s / 3600) % 24, m: Math.floor(s / 60) % 60, s: s % 60 };
        Array.prototype.forEach.call(slots, function (slot) {
          var v = vals[slot.getAttribute('data-unit')];
          var b = slot.querySelector('b');
          if (b) b.textContent = String(v).padStart(2, '0');
        });
        if (s === 0) {
          clearInterval(el._bbwTimer);
          if (note) { el.style.display = 'none'; note.hidden = false; }
        }
      };
      tick();
      el._bbwTimer = setInterval(tick, 1000);
    });
  }

  /* ——— Verkaufsbalken füllt sich ——— */
  function initMeter(root) {
    var els = (root || document).querySelectorAll('.bbw-root .meter-fill[data-pct]');
    Array.prototype.forEach.call(els, function (el) {
      var pct = parseFloat(el.getAttribute('data-pct')) || 0;
      setTimeout(function () { el.style.width = pct + '%'; }, 400);
    });
  }

  /* ——— Mobile Kaufleiste ——— */
  function initSticky() {
    var bar = document.querySelector('.bbw-sticky-buy');
    if (!bar) return;
    var after = parseInt(bar.getAttribute('data-after'), 10) || 700;
    var f = function () { bar.classList.toggle('on', window.scrollY > after); };
    f();
    window.addEventListener('scroll', f, { passive: true });
  }

  /* ——— Mengenwähler + Live-Preis ——— */
  function initQty(root) {
    var boxes = (root || document).querySelectorAll('.bbw-root [data-bbw-qty]');
    Array.prototype.forEach.call(boxes, function (box) {
      var input = box.querySelector('input[name="quantity"]');
      if (!input) return;
      var max = parseInt(box.getAttribute('data-max'), 10) || 5;
      var unit = parseInt(box.getAttribute('data-unit-price'), 10) || 0;      // Cent
      var compare = parseInt(box.getAttribute('data-compare-price'), 10) || 0; // Cent
      var elNow = box.querySelector('[data-price-now]');
      var elWas = box.querySelector('[data-price-was]');
      var elSave = box.querySelector('[data-price-save]');
      var elHint = box.querySelector('[data-qty-hint]');
      var hintOne = box.getAttribute('data-hint-one') || '';
      var hintMany = box.getAttribute('data-hint-many') || '';

      var fmt = function (cents) {
        return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
      };
      var sync = function () {
        var q = Math.max(1, Math.min(max, parseInt(input.value, 10) || 1));
        input.value = q;
        if (elNow && unit) elNow.textContent = fmt(unit * q);
        if (elWas && compare) elWas.textContent = fmt(compare * q);
        if (elSave && compare > unit) elSave.textContent = elSave.getAttribute('data-tpl').replace('[n]', fmt((compare - unit) * q));
        if (elHint) elHint.textContent = q > 1 ? hintMany : hintOne;
      };
      box.addEventListener('click', function (e) {
        var step = e.target.closest ? e.target.closest('[data-step]') : null;
        if (!step || !box.contains(step)) return;
        e.preventDefault();
        input.value = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-step'), 10);
        sync();
      });
      input.addEventListener('change', sync);
      input.addEventListener('input', sync);
      sync();
    });
  }

  /* ——— Klick-Verhalten: Spoiler, Türchen, FAQ, Etappen ——— */
  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var spoiler = t.closest('.bbw-root .spoiler');
    if (spoiler) {
      var panel = document.getElementById(spoiler.getAttribute('aria-controls'));
      var open = spoiler.classList.toggle('on');
      spoiler.setAttribute('aria-expanded', open ? 'true' : 'false');
      var label = spoiler.querySelector('[data-label]');
      if (label) label.textContent = open ? spoiler.getAttribute('data-label-close') : spoiler.getAttribute('data-label-open');
      if (panel) panel.classList.toggle('open', open);
      return;
    }

    var tuer = t.closest('.bbw-root .tuer');
    if (tuer) {
      var isOpen = tuer.classList.toggle('open');
      tuer.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      return;
    }

    var faqQ = t.closest('.bbw-root .faq-q');
    if (faqQ) {
      var item = faqQ.parentNode;
      var wasOpen = item.classList.contains('open');
      var list = item.parentNode;
      Array.prototype.forEach.call(list.querySelectorAll('.faq-item'), function (i) {
        i.classList.remove('open');
        var b = i.querySelector('.faq-q'); if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) { item.classList.add('open'); faqQ.setAttribute('aria-expanded', 'true'); }
      return;
    }

    var stage = t.closest('.bbw-root .stage');
    if (stage) { activateStage(stage); return; }
  }

  function activateStage(stage) {
    var list = stage.parentNode;
    var idx = Array.prototype.indexOf.call(list.querySelectorAll('.stage'), stage);
    Array.prototype.forEach.call(list.querySelectorAll('.stage'), function (s) { s.classList.remove('on'); });
    stage.classList.add('on');
    var sec = stage.closest('.bbw-climb');
    if (!sec) return;
    Array.prototype.forEach.call(sec.querySelectorAll('[data-seg]'), function (p) {
      p.setAttribute('stroke', parseInt(p.getAttribute('data-seg'), 10) === idx ? '#D98A6C' : 'transparent');
    });
  }

  function onOver(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var stage = t.closest('.bbw-root .stage');
    if (stage) activateStage(stage);
  }

  function initAll(root) {
    initReveal(root);
    initCountdown(root);
    initMeter(root);
    initQty(root);
  }

  function boot() {
    initAll(document);
    initProgress();
    initSticky();
    document.addEventListener('click', onClick);
    document.addEventListener('mouseover', onOver);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme-Editor: neu geladene Sektionen erneut verdrahten */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    initSticky();
  });
})();
